var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboarscout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98412 4.16402C1.76932 2.872 2.76577 1.69622 4.07552 1.69622H22.395C23.7154 1.69622 24.7146 2.89011 24.482 4.18983L22.2595 16.6079C22.0786 17.6186 21.1994 18.3545 20.1726 18.3545H6.13998C5.10325 18.3545 4.21859 17.6047 4.04857 16.5821L1.98412 4.16402Z",
    stroke: "#F2EADF",
    strokeWidth: 1.81724
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69946 8.49194L5.06672 7.71283L7.77215 7.45312L8.95578 7.71283L9.80123 7.90761L10.4776 8.21059L11.6612 8.96806L12.8448 10.0285L14.0285 10.9591L14.5357 11.2405L15.7194 11.6084L18.4248 11.8681L20.2848 11.6084L21.6375 10.786L23.8357 7.45312L22.3239 18.3607H4.16558L2.69946 8.49194Z",
    fill: "#F2EADF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19238 8.65721C2.19238 8.65721 4.80747 7.45312 7.72717 7.45312C10.6469 7.45312 12.845 10.18 12.845 10.18C12.845 10.18 14.4495 11.8681 18.4663 11.8681C22.4831 11.8681 23.1595 7.75611 23.1595 7.75611",
    stroke: "#F2EADF",
    strokeWidth: 0.245573
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboarscout);
export default __webpack_public_path__ + "static/media/dashboarscout.4b40790b27db22f54c2fb48ca1cef217.svg";
export { ForwardRef as ReactComponent };